/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
import React from 'react';
import { RouteComponentProps, matchPath } from 'react-router-dom';
import { PageNotFound } from 'shared/components';
import { Container } from './Styles';
import CreateIndividual from './CreateIndividual';
import EditIndividual from './EditIndividual';

const IndividualDetail: React.FC<RouteComponentProps> = (props) => {
  const { location } = props;

  let content = <PageNotFound />;

  const matchPage = (path: string) => {
    return !!matchPath(location.pathname, path);
  };

  if (matchPage(`/setting/creditor/individual/create`)) {
    content = <CreateIndividual />;
  } else if (matchPage(`/setting/creditor/individual/edit`)) {
    content = <EditIndividual />;
  }

  return <Container>{content}</Container>;
};

export default IndividualDetail;
